import { Injectable } from '@angular/core';

import { AuthHttp } from 'angular2-jwt';
import 'rxjs/add/operator/toPromise';

import { environment } from '../../../../environments/environment';

/** Uma linha da lista de conversas (ADR-0029). */
export interface ResumoDaConversa {
  id: number;
  grupo: boolean;
  /** Num grupo, o assunto. Numa individual, o nome da OUTRA pessoa. */
  titulo: string;
  participantes: string[];
  ultimaMensagem: string;
  ultimaEm: string;
  /** Calculado pela marca d'água, sem contar as próprias mensagens. */
  naoLidas: number;
}

export interface MensagemInterna {
  id: number;
  conversaInternaId: number;
  usuarioId: number;
  texto: string;
  /** O nome original do arquivo. */
  anexo: string;
  /** A chave de armazenamento — não é um hash, apesar do nome (ADR-0026). */
  hashFile: string;
  enviadaEm: string;
  autorNome: string;
  /** A tela alinha as minhas de um lado e as dos outros do outro. */
  minha: boolean;
}

/**
 * Mensageria interna (ADR-0029, POC item 66).
 *
 * Sem permissão nova: qualquer usuário logado conversa com qualquer outro.
 */
@Injectable()
export class MensageriaService {

  url: string;

  constructor(private http: AuthHttp) {
    this.url = `${environment.apiUrl}/mensageria`;
  }

  conversas(): Promise<ResumoDaConversa[]> {
    return this.http.get(`${this.url}/conversas`)
      .toPromise().then(r => r.json() as ResumoDaConversa[]);
  }

  /**
   * O numerinho do cabeçalho.
   *
   * Endpoint próprio, e leve, porque é consultado a cada cinco segundos: contar
   * carregando as mensagens seria uma consulta por conversa.
   */
  naoLidas(): Promise<number> {
    return this.http.get(`${this.url}/nao-lidas`)
      .toPromise().then(r => r.json().total as number);
  }

  mensagens(conversaId: number): Promise<MensagemInterna[]> {
    return this.http.get(`${this.url}/conversas/${conversaId}/mensagens`)
      .toPromise().then(r => r.json() as MensagemInterna[]);
  }

  usuarios(busca?: string): Promise<any[]> {
    const filtro = busca ? `?busca=${encodeURIComponent(busca)}` : '';
    return this.http.get(`${this.url}/usuarios${filtro}`)
      .toPromise().then(r => r.json());
  }

  abrirIndividual(usuarioId: number): Promise<any> {
    return this.http.post(`${this.url}/conversas/individual`,
      JSON.stringify({ usuarioId })).toPromise().then(r => r.json());
  }

  abrirGrupo(assunto: string, usuarios: number[]): Promise<any> {
    return this.http.post(`${this.url}/conversas/grupo`,
      JSON.stringify({ assunto, usuarios })).toPromise().then(r => r.json());
  }

  enviar(conversaId: number, texto: string, anexo?: string, hashFile?: string): Promise<any> {
    return this.http.post(`${this.url}/conversas/${conversaId}/mensagens`,
      JSON.stringify({ texto, anexo, hashFile })).toPromise().then(r => r.json());
  }

  marcarLida(conversaId: number): Promise<void> {
    return this.http.post(`${this.url}/conversas/${conversaId}/lida`, '')
      .toPromise().then(() => null);
  }

  sair(conversaId: number): Promise<void> {
    return this.http.post(`${this.url}/conversas/${conversaId}/sair`, '')
      .toPromise().then(() => null);
  }
}
